// pages/Testimonials.js — mobile responsive

import React, { useEffect, useState, useCallback } from 'react';
import CtaBand from '../components/CtaBand';

const testimonials = [
  { text: `"I would highly recommend this company if you’re looking a new kitchen design. Jamie and his team are so friendly, tidy and professional.

Jamie gave us lots of designs to pick from and during our kitchen renovation nothing was too much trouble. Everything he does is for the customer.

No job is too big or too small. We totally transformed our living space, knocking out glass blocks and putting windows in their place, knocking back walls to bring in more light, leveling 3 separate floors and replacing French doors. We didn’t even feel like any of this was hassle because of the professionalism and good friendly banter from Jamie and his team.

If you’re thinking of upgrading your kitchen look no further than urban kitchens.

Thanks Jamie, Conor, Jordy, and Gerry we love our new space. 😊"`, name: 'Sharon Robinson', location: 'Derriaghy', date: 'June 2026', images: ['/images/derriaghy1.JPG', '/images/derriaghy2.JPG', '/images/derriaghy3.JPG', '/images/derriaghy4.JPG'] },
  { text: `"Jamie and the team excellent workers. Very skilful and listened and delivered exactly what we wanted."`, name: 'Nuala Curley', location: 'Carryduff', date: 'July 2026', images: ['/images/Nuala-kitchen.jpg', '/images/Nuala-kitchen1.jpg', '/images/Nuala-kitchen2.jpg', '/images/Nuala-kitchen3.jpg', '/images/Nuala-kitchen4.jpg', '/images/Nuala-kitchen5.jpg', '/images/Nuala-kitchen7.jpg'] },
  { text: `"We were lucky enough to have Jamie and the team at Urban Kitchens install a new kitchen for us. From the beginning the whole process was hassle free, Jamie came out to our home to discuss ideas & get a feel for what we wanted. He then drew up plans for us and his eye for design is brilliant. He answered my many, many questions and listened to any concerns I had. The team done absolutely everything for us, they tore out our old kitchen, plastering, electrical work, plumbing & joinery as well as taking all rubbish away with them. They left our home tidy at the end of each day and we had no problems at all, any issues they came across were dealt with professionally & easily. The team were easy to communicate with & nothing was ever too much trouble for them - we decided on a Saturday that we wanted to add new flooring to our design and it was fitted on the Monday! Conor done all of the joinery work in our kitchen to such a high standard & his work is outstanding. We are absolutely delighted with our new kitchen and we can't recommend Urban Kitchens enough!"`, name: 'Lisa', location: 'Belfast', date: 'June 2026', images: ['/images/east-belfast.jpg', '/images/east-belfast2.jpg', '/images/east-belfast3.jpg', '/images/east-belfast4.jpg', '/images/east-belfast5.jpg', '/images/east-belfast6.jpg', '/images/east-belfast7.jpg', '/images/east-belfast8.jpg'] },
  { text: `"We're absolutely delighted with our new kitchen. From the very start, Jamie took the time to understand what we wanted and offered honest, practical suggestions that really improved the final design. Nothing felt rushed and the attention to detail throughout the process was excellent. The installation team were professional, tidy and transformed how we use our home. It's rare to find a business that combines great craftsmanship with such genuine customer care. Highly recommended."`, name: 'Ibe Sesay', location: 'Lisburn', date: 'September 2025' },
  { text: `"From the first conversation to the final install, the whole experience was a breath of fresh air. Jamie runs the business with a level of care you don't see very often anymore — thoughtful advice, zero pressure, and real attention to what we actually wanted to use the kitchen for day to day. Everything was handled smoothly, timelines were clear, and any questions we had were answered straight away. We honestly love spending time in our kitchen now, which says everything. Couldn't recommend Jamie and the team more highly."`, name: 'Jonathan Rea', location: 'Belfast', date: 'July 2024' },
  { text: `"I recently had Jamie at Urban Kitchens design and install my new kitchen back in 2022, and I can honestly say it exceeded every expectation. From the outset, Jamie's approach was refreshingly different - rather than playing it safe, he proposed an unconventional Scandinavian-inspired layout with an island positioned centrally in the space. I'll admit I needed a little convincing, but it turned out to be a stroke of genius.\n\nThe island has completely transformed how we use the kitchen. From the initial consultation right through to the final installation, nothing was ever too much trouble. Jamie answered every question, addressed every concern, and made the whole process remarkably smooth. The craftsmanship speaks for itself.\n\nIf you're looking for a kitchen designer who'll actually listen, bring fresh ideas, and deliver on every promise - Jamie is your man. Look no further."`, name: 'M. Haughey', location: 'Dunmurry', date: 'August 2022' },
];

const stats = [
  { num: '200+', label: 'Projects Completed' },
  { num: '99%',  label: 'Client Satisfaction' },
  { num: '25+',  label: 'Years Experience' },
  { num: '5★',   label: 'Average Rating' },
];

export default function Testimonials() {
  const [lightbox, setLightbox] = useState(null); // { images, index }

  useEffect(() => { window.scrollTo({ top: 0 }); }, []);

  const closeLightbox = useCallback(() => {
    setLightbox(null);
    document.body.style.overflow = '';
  }, []);

  const openLightbox = (images, index) => {
    setLightbox({ images, index });
    document.body.style.overflow = 'hidden';
  };

  const goNext = useCallback(() => {
    setLightbox(lb => ({ ...lb, index: (lb.index + 1) % lb.images.length }));
  }, []);

  const goPrev = useCallback(() => {
    setLightbox(lb => ({ ...lb, index: (lb.index - 1 + lb.images.length) % lb.images.length }));
  }, []);

  useEffect(() => {
    const handleKey = (e) => {
      if (!lightbox) return;
      if (e.key === 'Escape')     closeLightbox();
      if (e.key === 'ArrowRight') goNext();
      if (e.key === 'ArrowLeft')  goPrev();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [lightbox, closeLightbox, goNext, goPrev]);

  return (
    <div className="page-wrapper--inner">
      <div style={{ height: "60px" }} />
      <style>{`
        .test-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1.5rem;
          margin-bottom: 5rem;
        }
        .testimonial-card {
          transition: background 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;
        }
        .testimonial-card:hover {
          background: rgba(232,130,26,0.16);
          border-color: rgba(232,130,26,0.35);
          box-shadow: inset 0 0 0 1px rgba(232,130,26,0.22);
        }
        .stats-bar {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          border: 1px solid var(--border);
        }
        @media (max-width: 768px) {
          .test-grid { grid-template-columns: 1fr; }
          .stats-bar { grid-template-columns: 1fr 1fr; }
        }
        @media (max-width: 400px) {
          .stats-bar { grid-template-columns: 1fr 1fr; }
        }
      `}</style>

      <section className="section">
        <div className="container">
          <div className="label">Client Stories</div>
          <h2 className="heading-xl">What Our<br /><span className="orange-italic">Clients Say</span></h2>
          <br />
          <p className="subtext" style={{ maxWidth: 560, marginBottom: '1.5rem' }}>
            Don't just take our word for it. Hear from the homeowners who have trusted us to transform their kitchens.
          </p>
          <div style={s.reviewLinkWrap}>
            <a
              href="https://www.google.com/search?sca_esv=a75f3b595b8525f4&rlz=1C5CHFA_enGB833GB833&si=APenkKm7iecQ4G6P-TsbSMFKIQtv3EFIqRAFw-i8uEbk55Z-__TzVWADptuEtU1l6nvB6cvHLKW71lzLvFGaSNEeC0IoOzdVb_IyvLFs9jSb5eAOkLXVPJbSxDW7fH0R2O-bX89alIHkDP20PWj4l9i9i8noU-E-gg%3D%3D&q=Urban+Kitchens+KDC+Ltd+Reviews&sa=X&biw=1680&bih=872&dpr=2&zx=1784632223501&dlnr=1&ved=2ahUKEwjC2ZaO0eOVAxU3REEAHe7cJw0Ql6ENegQICRAG"
              target="_blank"
              rel="noreferrer"
              style={s.googleReviewLink}
            >
              <span style={s.googleIcon}>G</span>
              <span>See Google Reviews</span>
            </a>
          </div>

          <div className="test-grid">
            {testimonials.map((t, i) => (
              <div key={i} className="testimonial-card" style={s.card}>
                <div style={s.quote}>❝❞</div>
                <p style={s.text}>{t.text}</p>
                {t.images && (
                  <div style={s.thumbRow}>
                    {t.images.map((src, j) => (
                      <img
                        key={j}
                        src={src}
                        alt={`${t.name}'s kitchen`}
                        style={{ ...s.thumb, cursor: 'pointer' }}
                        onClick={() => openLightbox(t.images, j)}
                      />
                    ))}
                  </div>
                )}
                <div style={s.stars}>★★★★★</div>
                <div style={s.name}>{t.name}</div>
                <div style={s.loc}>{t.location}{t.location && t.date ? ' · ' : ''}{t.date}</div>
              </div>
            ))}
          </div>

          <div className="stats-bar">
            {stats.map((stat, i) => (
              <div key={i} style={{ ...s.statsCell, borderRight: i < stats.length - 1 ? '1px solid var(--border)' : 'none' }}>
                <div style={s.statsNum}>{stat.num}</div>
                <div style={s.statsLabel}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaBand
        title="Join Our Satisfied Clients"
        text="Ready to experience the Urban Kitchens difference? Let's start your journey."
        buttons={[{ label: 'Book a Consultation', to: '/contact' }]}
      />

      {lightbox && (
        <div style={s.lightboxOverlay} onClick={closeLightbox}>
          <button style={s.lightboxClose} onClick={closeLightbox}>✕</button>
          <div style={s.lightboxCounter}>{lightbox.index + 1} / {lightbox.images.length}</div>
          <button style={{ ...s.navBtn, left: '1rem' }} onClick={e => { e.stopPropagation(); goPrev(); }}>‹</button>
          <img src={lightbox.images[lightbox.index]} alt="Kitchen" style={s.lightboxImg} onClick={e => e.stopPropagation()} />
          <button style={{ ...s.navBtn, right: '1rem' }} onClick={e => { e.stopPropagation(); goNext(); }}>›</button>
          <div style={s.keyHint}>← → arrow keys to navigate · Esc to close</div>
        </div>
      )}
    </div>
  );
}

const s = {
  reviewLinkWrap: { marginBottom: '2rem' },
  googleReviewLink: { display: 'inline-flex', alignItems: 'center', gap: '0.75rem', padding: '0.85rem 1.15rem', borderRadius: '999px', border: '1px solid rgba(232,130,26,0.25)', background: 'var(--bg3)', color: 'var(--text)', textDecoration: 'none', fontWeight: 500, transition: 'transform 0.2s ease, box-shadow 0.2s ease' },
  googleIcon: { width: 30, height: 30, borderRadius: '50%', background: '#4285F4', color: '#fff', display: 'grid', placeItems: 'center', fontSize: '1rem', fontWeight: 700 },
  card: { background: 'var(--bg3)', border: '1px solid var(--border)', padding: '2.5rem' },
  quote: { fontSize: '2.5rem', color: 'rgba(232,130,26,0.3)', fontFamily: 'serif', lineHeight: 1, marginBottom: '1.5rem' },
  text: { color: 'var(--text-muted)', fontSize: '0.88rem', lineHeight: 1.9, marginBottom: '2rem', fontStyle: 'normal' },
  thumbRow: { display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '1.5rem' },
  thumb: { width: 72, height: 72, objectFit: 'cover', flexShrink: 0, borderRadius: '8px' },
  stars: { color: 'var(--orange)', fontSize: '0.9rem', marginBottom: '0.75rem' },
  name: { fontFamily: "'Cormorant Garamond', serif", fontSize: '1.1rem', fontWeight: 500 },
  loc: { fontSize: '0.78rem', color: 'var(--text-muted)' },
  statsCell: { padding: '2.5rem 1rem', textAlign: 'center' },
  statsNum: { fontFamily: "'Cormorant Garamond', serif", fontSize: 'clamp(2rem,4vw,3rem)', color: 'var(--orange)', lineHeight: 1, marginBottom: '0.5rem' },
  statsLabel: { fontSize: '0.65rem', fontWeight: 500, letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--text-muted)' },
  lightboxOverlay: { position: 'fixed', inset: 0, zIndex: 2000, background: 'rgba(0,0,0,0.95)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', cursor: 'pointer' },
  lightboxImg:     { maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain', boxShadow: '0 25px 80px rgba(0,0,0,0.8)', cursor: 'default' },
  lightboxClose:   { position: 'fixed', top: '1.5rem', right: '1.5rem', background: 'none', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', fontSize: '1.2rem', width: 40, height: 40, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', zIndex: 1 },
  lightboxCounter: { position: 'fixed', top: '1.5rem', left: '1.5rem', color: 'var(--text-muted)', fontSize: '0.82rem', letterSpacing: '0.1em' },
  navBtn:          { position: 'fixed', top: '50%', transform: 'translateY(-50%)', background: 'rgba(232,130,26,0.15)', border: '1px solid rgba(232,130,26,0.4)', color: 'var(--orange)', fontSize: '2.5rem', lineHeight: 1, width: 56, height: 56, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s', zIndex: 1 },
  keyHint:         { position: 'fixed', bottom: '1.5rem', color: 'var(--text-dim)', fontSize: '0.75rem', letterSpacing: '0.05em' },
};
